<template>
  <v-row dense class="mb-10">
    <v-col cols="12">
      <v-card light class="boarding mt-5">
        <v-card-title class="d-flex justify-space-between"
          >{{ doc.selectedPlane.title }}
          <v-icon class="align-self-start"
            >mdi-airplane-takeoff</v-icon
          ></v-card-title
        >
        <v-card-subtitle class="subtitle-2">Boarding pass</v-card-subtitle>
        <v-card-text class="p1-5">
          <v-row>
            <v-col
              cols="6"
              v-for="field in fields"
              :key="`model-${field.model}`"
            >
              <v-textarea
                :label="field.title"
                v-model.trim="doc.ticket[field.model]"
                type="text"
                auto-grow
                :placeholder="field.description"
                :id="field.title"
                color="amber"
                @blur="$emit('doAutoSave')"
                :diabled="true"
              ></v-textarea>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions class="d-flex justify-space-between">
          <span class="body-2 align-self-end">Non-refundable</span
          ><span class="body-2">{{ Date.now() }}</span
          ><span class="body-2">Please board 20 minutes before departure</span
          ><v-icon class="align-self-start">mdi-airplane-takeoff</v-icon>
        </v-card-actions>
      </v-card>
    </v-col>
  </v-row>
</template>
<script>
export default {
  name: "FlyTicket",
  props: {
    doc: { type: Object, default: () => {} },
  },
  data() {
    return {
      fields: [
        {
          title: "Check-in",
          model: "checkin",
          description: "How would it work and feel to check in?",
        },
        {
          title: "Ticket Price",
          model: "ticket",
          description: "How expensive or cheap would it be?",
        },
        {
          title: "Classes",
          model: "classes",
          description: "How could passengers be grouped?",
        },
        {
          title: "Passengers",
          model: "passengers",
          description: "What kind of people would be on board?",
        },
        {
          title: "Destinations",
          model: "destinations",
          description: "Where would it fly to?",
        },
        {
          title: "Entertainment and Services",
          model: "entertainment",
          description: "What kind would be available?",
        },
        {
          title: "Music",
          model: "music",
          description: "What music would they play before takeoff?",
        },
        {
          title: "Catering",
          model: "catering",
          description: "What kind of food and drink would be served?",
        },
        {
          title: "Crew",
          model: "crew",
          description: "What kind of people would they be?",
        },
        {
          title: "Ambience",
          model: "ambience",
          description: "How would it feel on board eg calm, happy?",
        },
      ],
    };
  },
};
</script>
